// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const TicketDiscountIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "TicketDiscount/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.75 9.033a.58.58 0 0 0 .583-.583v-.775c0-3.417-1.041-4.458-4.458-4.458h-7.75c-3.417 0-4.458 1.041-4.458 4.458v.392a.58.58 0 0 0 .583.583c.75 0 1.358.608 1.358 1.358 0 .75-.608 1.35-1.358 1.35a.58.58 0 0 0-.583.584v.391c0 3.417 1.041 4.459 4.458 4.459h7.75c3.417 0 4.458-1.042 4.458-4.459a.58.58 0 0 0-.583-.583 1.359 1.359 0 0 1 0-2.717ZM7.5 7.4c.458 0 .833.375.833.833a.83.83 0 0 1-.833.834.836.836 0 0 1-.833-.834A.83.83 0 0 1 7.5 7.4Zm5 5.833a.838.838 0 0 1-.842-.833c0-.458.375-.833.834-.833.458 0 .833.375.833.833a.823.823 0 0 1-.825.833Zm.75-5.333-5.608 5.608a.618.618 0 0 1-.442.184.618.618 0 0 1-.442-.184.629.629 0 0 1 0-.883l5.609-5.608a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883Z"
}));
export default TicketDiscountIcon;